var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { registerForIntl, provideIntlService } from '@progress/kendo-react-intl';
import { classNames } from '@progress/kendo-react-common';
import { getNestedValue } from '../utils';
var TreeListCell = /** @class */ (function (_super) {
    __extends(TreeListCell, _super);
    function TreeListCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @hidden
     */
    TreeListCell.prototype.render = function () {
        var _this = this;
        var _a;
        var _b = this.props, hasChildren = _b.hasChildren, _c = _b.level, level = _c === void 0 ? [0] : _c, expanded = _b.expanded, dataItem = _b.dataItem, format = _b.format;
        var data = getNestedValue(this.props.field, dataItem);
        var dataAsString = '';
        if (data !== undefined && data !== null) {
            dataAsString = format ?
                provideIntlService(this).format(format, data) :
                data.toString();
        }
        var icons = [];
        if (this.props.expandable) {
            icons.push.apply(icons, level.slice(1).map(function (_x, i) { return (React.createElement("span", { className: "k-icon k-i-none", key: i })); }));
            if (hasChildren) {
                icons.push(React.createElement("span", { className: "k-icon k-i-" + (expanded ? 'collapse' : 'expand'), key: "expand-collapse", onClick: function (event) { return _this.props.onExpandChange(event, dataItem, level); } }));
            }
            else {
                icons.push(React.createElement("span", { className: "k-icon k-i-none", key: icons.length }));
            }
        }
        var defaultRendering = (React.createElement("td", { style: this.props.style, className: classNames(this.props.className, (_a = {},
                _a['k-text-nowrap'] = this.props.expandable,
                _a)), colSpan: this.props.colSpan },
            icons,
            dataAsString));
        return this.props.render ?
            this.props.render.call(undefined, defaultRendering, this.props) :
            defaultRendering;
    };
    return TreeListCell;
}(React.Component));
export { TreeListCell };
registerForIntl(TreeListCell);
//# sourceMappingURL=TreeListCell.js.map